export function getUserTimezone(): string {
  return Intl.DateTimeFormat().resolvedOptions().timeZone
}

export function getTimezoneLongName(): string {
  const parts = new Intl.DateTimeFormat('en', { timeZoneName: 'long' }).formatToParts(new Date())
  return parts.find((p) => p.type === 'timeZoneName')?.value ?? Intl.DateTimeFormat().resolvedOptions().timeZone
}

/** Whether `Intl` accepts `zone`; a stored label like `America / Denver` does not. */
export function isValidTimeZone(zone: string): boolean {
  try {
    new Intl.DateTimeFormat('en-US', { timeZone: zone })
    return true
  } catch {
    return false
  }
}
